/**
 * Enum loại nghiệp vụ KB điện tử
 * nthien4 06.10.2022
 */
export default {
  BUPlanWithdrawTransfer: 1,
  BUPlanWithdrawSalaryTransfer: 2,
  BUPlanWithdrawDeposit: 3,
  BUPlanWithdrawCash: 4,
  CAReceiptWithdraw: 5,
  PaymentSalary: 17,
  EMoneyTransfer: 6,
  PUInvoice: 7,
  PayFees: 8,
  BUVoucherListRealExpense: 9,
  GLVoucherSummaryTable: 10,
  BUVoucherListReceipExpense: 11,
  BUInvestmentWithdrawTransfer: 14,
  BUInvestmentWithdrawCash: 15,
  BUInvestment: 16,
};
